<div class="section-container text-size-large">
  <div class="section" [class.text-strike-through]="item.status === 'REVERSED'">
    <span class="font-bold">{{ item.quantity | number: '1.0-8' }}</span>
    @if (item.date) {
      <span class="font-bold">{{ item.date | date: 'shortDate' }}</span>
    } @else {
      <span>&mdash;</span>
    }
  </div>
  <div class="section">
    @if (item.pricePerUnit) {
      <span class="d-flex align-items-center flex-wrap" [class.text-strike-through]="item.status === 'REVERSED'">
        <span class="font-bold">{{ item.pricePerUnit | number: '1.2-2' }}&nbsp;€</span>
        @if (item.pricePerUnitBeforeTax && item.pricePerUnitBeforeTax !== item.pricePerUnit) {
          &nbsp;<span class="text-size-small">
            ({{ 'instrument-detail.asset-timeline.item.before-tax' | transloco }}
            {{ item.pricePerUnitBeforeTax | number: '1.2-2' }}&nbsp;€)</span
          >
        }
      </span>
    } @else {
      <span class="font-bold">&mdash;</span>
    }
    <span>{{ item.typeDisplayValue }}</span>
  </div>
  <div class="section">
    @if (item.amount) {
      <span class="d-flex align-items-center flex-wrap" [class.text-strike-through]="item.status === 'REVERSED'">
        <span
          class="font-bold"
          [class.text-color-error]="item.amount < 0"
          [class.text-color-success]="item.amount > 0"
          [class.text-strike-through]="item.status === 'REVERSED'"
        >
          {{ (item.amount > 0 ? '+' : '') + (item.amount | number: '1.2-2') }}&nbsp;€
        </span>
        @if (item.amountBeforeTax && item.amountBeforeTax !== item.amount) {
          &nbsp;<span class="text-size-small"
            >({{ 'instrument-detail.asset-timeline.item.before-tax' | transloco }}
            {{ (item.amountBeforeTax > 0 ? '+' : '') + (item.amountBeforeTax | number: '1.2-2') }}&nbsp;€)</span
          >
        }
      </span>
    } @else {
      <span class="font-bold">&mdash;</span>
    }
    <span>{{ item.statusDisplayValue }}</span>
  </div>
</div>
